export default __webpack_public_path__ + "static/media/teamDirectoryActiveIcon.280432b4.svg";